// app/redux/actions/noteDeFraisActions.js

// =========================
// FETCH ALL
// =========================
export const FETCH_NOTE_DE_FRAIS_REQUEST = "FETCH_NOTE_DE_FRAIS_REQUEST";
export const FETCH_NOTE_DE_FRAIS_SUCCESS = "FETCH_NOTE_DE_FRAIS_SUCCESS";
export const FETCH_NOTE_DE_FRAIS_FAIL = "FETCH_NOTE_DE_FRAIS_FAIL";

// =========================
// GET BY ID
// =========================
export const FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST = "FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST";
export const FETCH_NOTE_DE_FRAIS_BY_ID_SUCCESS = "FETCH_NOTE_DE_FRAIS_BY_ID_SUCCESS";
export const FETCH_NOTE_DE_FRAIS_BY_ID_FAIL = "FETCH_NOTE_DE_FRAIS_BY_ID_FAIL";

// =========================
// CREATE
// =========================
export const CREATE_NOTE_DE_FRAIS_REQUEST = "CREATE_NOTE_DE_FRAIS_REQUEST";
export const CREATE_NOTE_DE_FRAIS_SUCCESS = "CREATE_NOTE_DE_FRAIS_SUCCESS";
export const CREATE_NOTE_DE_FRAIS_FAIL = "CREATE_NOTE_DE_FRAIS_FAIL";

// =========================
// UPDATE
// =========================
export const UPDATE_NOTE_DE_FRAIS_REQUEST = "UPDATE_NOTE_DE_FRAIS_REQUEST";
export const UPDATE_NOTE_DE_FRAIS_SUCCESS = "UPDATE_NOTE_DE_FRAIS_SUCCESS";
export const UPDATE_NOTE_DE_FRAIS_FAIL = "UPDATE_NOTE_DE_FRAIS_FAIL";

// =========================
// DELETE
// =========================
export const DELETE_NOTE_DE_FRAIS_REQUEST = "DELETE_NOTE_DE_FRAIS_REQUEST";
export const DELETE_NOTE_DE_FRAIS_SUCCESS = "DELETE_NOTE_DE_FRAIS_SUCCESS";
export const DELETE_NOTE_DE_FRAIS_FAIL = "DELETE_NOTE_DE_FRAIS_FAIL";

// =========================
// FETCH ACTIFS
// =========================
export const FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST = "FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST";
export const FETCH_NOTE_DE_FRAIS_ACTIFS_SUCCESS = "FETCH_NOTE_DE_FRAIS_ACTIFS_SUCCESS";
export const FETCH_NOTE_DE_FRAIS_ACTIFS_FAIL = "FETCH_NOTE_DE_FRAIS_ACTIFS_FAIL";

// =========================
// LOADING / ERROR
// =========================
export const SET_NOTE_DE_FRAIS_LOADING = "SET_NOTE_DE_FRAIS_LOADING";
export const CLEAR_NOTE_DE_FRAIS_ERROR = "CLEAR_NOTE_DE_FRAIS_ERROR";

// =========================
// ACTION CREATORS
// =========================
export const setNoteDeFraisLoading = (loading) => ({
    type: SET_NOTE_DE_FRAIS_LOADING,
    payload: loading,
});

export const clearNoteDeFraisError = () => ({
    type: CLEAR_NOTE_DE_FRAIS_ERROR,
});

// FETCH ALL
export const fetchNoteDeFraisRequest = () => ({ type: FETCH_NOTE_DE_FRAIS_REQUEST });
export const fetchNoteDeFraisSuccess = (data) => ({ type: FETCH_NOTE_DE_FRAIS_SUCCESS, payload: data });
export const fetchNoteDeFraisFail = (error) => ({ type: FETCH_NOTE_DE_FRAIS_FAIL, payload: error });

// FETCH BY ID
export const fetchNoteDeFraisByIdRequest = (id) => ({ type: FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST, payload: id });
export const fetchNoteDeFraisByIdSuccess = (data) => ({ type: FETCH_NOTE_DE_FRAIS_BY_ID_SUCCESS, payload: data });
export const fetchNoteDeFraisByIdFail = (error) => ({ type: FETCH_NOTE_DE_FRAIS_BY_ID_FAIL, payload: error });

// CREATE
export const createNoteDeFraisRequest = (payload) => ({ type: CREATE_NOTE_DE_FRAIS_REQUEST, payload });
export const createNoteDeFraisSuccess = (created) => ({ type: CREATE_NOTE_DE_FRAIS_SUCCESS, payload: created });
export const createNoteDeFraisFail = (error) => ({ type: CREATE_NOTE_DE_FRAIS_FAIL, payload: error });

// UPDATE
export const updateNoteDeFraisRequest = (id, payload) => ({
    type: UPDATE_NOTE_DE_FRAIS_REQUEST,
    payload: { id, payload }
});
export const updateNoteDeFraisSuccess = (updated) => ({ type: UPDATE_NOTE_DE_FRAIS_SUCCESS, payload: updated });
export const updateNoteDeFraisFail = (error) => ({ type: UPDATE_NOTE_DE_FRAIS_FAIL, payload: error });

// DELETE
export const deleteNoteDeFraisRequest = (id) => ({ type: DELETE_NOTE_DE_FRAIS_REQUEST, payload: id });
export const deleteNoteDeFraisSuccess = (id) => ({ type: DELETE_NOTE_DE_FRAIS_SUCCESS, payload: id });
export const deleteNoteDeFraisFail = (error) => ({ type: DELETE_NOTE_DE_FRAIS_FAIL, payload: error });

// FETCH ACTIFS
export const fetchNoteDeFraisActifsRequest = () => ({ type: FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST });
export const fetchNoteDeFraisActifsSuccess = (data) => ({ type: FETCH_NOTE_DE_FRAIS_ACTIFS_SUCCESS, payload: data });
export const fetchNoteDeFraisActifsFail = (error) => ({ type: FETCH_NOTE_DE_FRAIS_ACTIFS_FAIL, payload: error });